import React, { useEffect, useState, createContext, useContext } from 'react';
export type Language = 'es' | 'en' | 'de' | 'pt' | 'zh';
type Translations = Record<string, string>;
const translations: Record<Language, Translations> = {
  es: {
    home: 'Inicio',
    restaurants: 'Restaurantes',
    search_placeholder: 'Buscar restaurantes o comidas...',
    hero_title1: 'El marketplace gastronómico de',
    hero_title2: 'Los Santos',
    view_order: 'Ver pedido',
    product: 'producto',
    products: 'productos',
    cart_empty: 'Tu carrito está vacío',
    cart_empty_desc: 'Aún no has agregado ningún producto a tu pedido. ¡Explora los restaurantes y encuentra algo delicioso!',
    explore: 'Explorar restaurantes',
    add_to_cart: 'Agregar al pedido',
    checkout: 'Proceder al pago',
    subtotal: 'Subtotal',
    total: 'Total',
    delivery_fee: 'Costo de envío',
    delivery: 'Delivery',
    pickup: 'Llevar',
    dine_in: 'Mesa',
    cart_title: 'Tu Pedido',
    cart_clear: 'Vaciar',
    cart_checkout: 'Ir a pagar',
    checkout_title: 'Confirmar Pedido',
    checkout_name: 'Nombre',
    checkout_phone: 'Teléfono',
    checkout_address: 'Dirección de entrega',
    checkout_payment: 'Método de pago',
    checkout_cash: 'Efectivo',
    checkout_card: 'Tarjeta',
    checkout_sinpe: 'SINPE Móvil',
    checkout_notes: 'Notas del pedido',
    checkout_notes_placeholder: 'Instrucciones especiales...',
    checkout_place_order: 'Enviar pedido',
    checkout_placing: 'Enviando...',
    checkout_terms: 'Acepto los términos y condiciones',
    checkout_delivery_type: 'Tipo de entrega',
    confirm_title: '¡Pedido enviado!',
    confirm_subtitle: 'Tu pedido ha sido recibido',
    confirm_order_number: 'Número de pedido',
    confirm_track: 'Seguir pedido',
    confirm_whatsapp: 'Enviar por WhatsApp',
    confirm_copy: 'Copiar enlace',
    confirm_copied: '¡Copiado!',
    confirm_no_order: 'No hay pedido reciente',
    confirm_back: 'Volver al inicio',
    tracking_title: 'Seguimiento de pedido',
    tracking_not_found: 'Pedido no encontrado',
    status_new: 'Pedido recibido',
    status_accepted: 'Pedido aceptado',
    status_preparing: 'En preparación',
    status_ready: 'Pedido listo',
    status_searching_driver: 'Buscando conductor',
    status_out_for_delivery: 'En camino',
    status_delivered: 'Entregado',
    status_cancelled: 'Cancelado',
    featured: 'Destacado',
    closed: 'Cerrado',
    free_delivery: 'Envío gratis',
    min_order: 'Pedido mínimo',
    customize: 'Personalizar',
    notes_placeholder: 'Instrucciones especiales...',
    required: 'Requerido',
    optional: 'Opcional',
    select_up_to: 'Selecciona hasta',
    kitchen_paused: 'Cocina en pausa',
    kitchen_paused_msg: 'El restaurante no está aceptando pedidos en este momento',
    back: 'Volver',
    close: 'Cerrar',
    loading: 'Cargando...',
    error: 'Error',
    retry: 'Reintentar',
    cancel: 'Cancelar',
    confirm: 'Confirmar',
    order_summary: 'Resumen del pedido',
    items: 'artículos',
    copy_tracking: 'Copiar enlace de seguimiento',
    all: 'Todas',
    all_restaurants: 'Todos los restaurantes',
    hero_subtitle: 'Descubre los mejores restaurantes de la zona y pide a domicilio o para llevar.',
    cat_food: 'Comida',
    cat_drinks: 'Bebidas',
    cat_desserts: 'Postres',
    cat_kids: 'Niños',
    recommended: 'Recomendados',
    explore: 'Explorar',
    menu: 'Menú',
    mcat_pizza: 'Pizza',
    mcat_hamburguesas: 'Hamburguesas',
    mcat_cafeteria: 'Cafetería',
    mcat_comida_tipica: 'Comida Típica',
    mcat_sushi: 'Sushi',
    mcat_parrilla: 'Parrilla',
    mcat_postres: 'Postres',
    mcat_mariscos: 'Mariscos',
    mcat_vegetariano: 'Vegetariano',
    mcat_asiatica: 'Asiática',
    mcat_mexicana: 'Mexicana',
    mcat_italiana: 'Italiana',
    mcat_bebidas: 'Bebidas',
    mcat_desayunos: 'Desayunos',
    all_zones: 'Todas las zonas',
    all_categories: 'Todas las categorías',
    no_restaurants: 'No se encontraron restaurantes',
    no_restaurants_desc: 'Intenta ajustar tus filtros de búsqueda para ver más resultados.',
    clear_filters: 'Limpiar filtros'
  },
  en: {
    home: 'Home',
    restaurants: 'Restaurants',
    search_placeholder: 'Search restaurants or food...',
    hero_title1: 'The gastronomic marketplace of',
    hero_title2: 'Los Santos',
    view_order: 'View order',
    product: 'item',
    products: 'items',
    cart_empty: 'Your cart is empty',
    cart_empty_desc: "You haven't added any products to your order yet. Explore restaurants and find something delicious!",
    explore: 'Explore restaurants',
    add_to_cart: 'Add to order',
    checkout: 'Checkout',
    subtotal: 'Subtotal',
    total: 'Total',
    delivery_fee: 'Delivery fee',
    delivery: 'Delivery',
    pickup: 'Pickup',
    dine_in: 'Dine-in',
    cart_title: 'Your Order',
    cart_clear: 'Clear',
    cart_checkout: 'Go to checkout',
    checkout_title: 'Confirm Order',
    checkout_name: 'Name',
    checkout_phone: 'Phone',
    checkout_address: 'Delivery address',
    checkout_payment: 'Payment method',
    checkout_cash: 'Cash',
    checkout_card: 'Card',
    checkout_sinpe: 'SINPE Móvil',
    checkout_notes: 'Order notes',
    checkout_notes_placeholder: 'Special instructions...',
    checkout_place_order: 'Place order',
    checkout_placing: 'Placing order...',
    checkout_terms: 'I accept the terms and conditions',
    checkout_delivery_type: 'Delivery type',
    confirm_title: 'Order placed!',
    confirm_subtitle: 'Your order has been received',
    confirm_order_number: 'Order number',
    confirm_track: 'Track order',
    confirm_whatsapp: 'Send via WhatsApp',
    confirm_copy: 'Copy link',
    confirm_copied: 'Copied!',
    confirm_no_order: 'No recent order',
    confirm_back: 'Back to home',
    tracking_title: 'Order tracking',
    tracking_not_found: 'Order not found',
    status_new: 'Order received',
    status_accepted: 'Order accepted',
    status_preparing: 'Preparing',
    status_ready: 'Order ready',
    status_searching_driver: 'Searching for driver',
    status_out_for_delivery: 'Out for delivery',
    status_delivered: 'Delivered',
    status_cancelled: 'Cancelled',
    featured: 'Featured',
    closed: 'Closed',
    free_delivery: 'Free delivery',
    min_order: 'Minimum order',
    customize: 'Customize',
    notes_placeholder: 'Special instructions...',
    required: 'Required',
    optional: 'Optional',
    select_up_to: 'Select up to',
    kitchen_paused: 'Kitchen paused',
    kitchen_paused_msg: 'The restaurant is not accepting orders right now',
    back: 'Back',
    close: 'Close',
    loading: 'Loading...',
    error: 'Error',
    retry: 'Retry',
    cancel: 'Cancel',
    confirm: 'Confirm',
    order_summary: 'Order summary',
    items: 'items',
    copy_tracking: 'Copy tracking link',
    all: 'All',
    all_restaurants: 'All restaurants',
    hero_subtitle: 'Discover the best restaurants in the area and order for delivery or pickup.',
    cat_food: 'Food',
    cat_drinks: 'Drinks',
    cat_desserts: 'Desserts',
    cat_kids: 'Kids',
    recommended: 'Recommended',
    explore: 'Explore',
    menu: 'Menu',
    mcat_pizza: 'Pizza',
    mcat_hamburguesas: 'Burgers',
    mcat_cafeteria: 'Café',
    mcat_comida_tipica: 'Local Food',
    mcat_sushi: 'Sushi',
    mcat_parrilla: 'Grill',
    mcat_postres: 'Desserts',
    mcat_mariscos: 'Seafood',
    mcat_vegetariano: 'Vegetarian',
    mcat_asiatica: 'Asian',
    mcat_mexicana: 'Mexican',
    mcat_italiana: 'Italian',
    mcat_bebidas: 'Drinks',
    mcat_desayunos: 'Breakfast',
    all_zones: 'All zones',
    all_categories: 'All categories',
    no_restaurants: 'No restaurants found',
    no_restaurants_desc: 'Try adjusting your search filters to see more results.',
    clear_filters: 'Clear filters'
  },
  de: {
    home: 'Startseite',
    restaurants: 'Restaurants',
    search_placeholder: 'Restaurants oder Essen suchen...',
    hero_title1: 'Der gastronomische Marktplatz von',
    hero_title2: 'Los Santos',
    view_order: 'Bestellung ansehen',
    product: 'Artikel',
    products: 'Artikel',
    cart_empty: 'Dein Warenkorb ist leer',
    cart_empty_desc: 'Du hast noch keine Produkte zu deiner Bestellung hinzugefügt. Entdecke Restaurants und finde etwas Leckeres!',
    explore: 'Restaurants erkunden',
    add_to_cart: 'Zur Bestellung hinzufügen',
    checkout: 'Zur Kasse',
    subtotal: 'Zwischensumme',
    total: 'Gesamt',
    delivery_fee: 'Liefergebühr',
    delivery: 'Lieferung',
    pickup: 'Abholung',
    dine_in: 'Im Restaurant',
    cart_title: 'Deine Bestellung',
    cart_clear: 'Leeren',
    cart_checkout: 'Zur Kasse',
    checkout_title: 'Bestellung bestätigen',
    checkout_name: 'Name',
    checkout_phone: 'Telefon',
    checkout_address: 'Lieferadresse',
    checkout_payment: 'Zahlungsmethode',
    checkout_cash: 'Bargeld',
    checkout_card: 'Karte',
    checkout_sinpe: 'SINPE Móvil',
    checkout_notes: 'Bestellnotizen',
    checkout_notes_placeholder: 'Besondere Anweisungen...',
    checkout_place_order: 'Bestellung aufgeben',
    checkout_placing: 'Wird gesendet...',
    checkout_terms: 'Ich akzeptiere die AGB',
    checkout_delivery_type: 'Lieferart',
    confirm_title: 'Bestellung aufgegeben!',
    confirm_subtitle: 'Deine Bestellung wurde empfangen',
    confirm_order_number: 'Bestellnummer',
    confirm_track: 'Bestellung verfolgen',
    confirm_whatsapp: 'Per WhatsApp senden',
    confirm_copy: 'Link kopieren',
    confirm_copied: 'Kopiert!',
    confirm_no_order: 'Keine aktuelle Bestellung',
    confirm_back: 'Zurück zur Startseite',
    tracking_title: 'Bestellverfolgung',
    tracking_not_found: 'Bestellung nicht gefunden',
    status_new: 'Bestellung eingegangen',
    status_accepted: 'Bestellung akzeptiert',
    status_preparing: 'In Zubereitung',
    status_ready: 'Bestellung fertig',
    status_searching_driver: 'Fahrer wird gesucht',
    status_out_for_delivery: 'Unterwegs',
    status_delivered: 'Geliefert',
    status_cancelled: 'Storniert',
    featured: 'Empfohlen',
    closed: 'Geschlossen',
    free_delivery: 'Kostenlose Lieferung',
    min_order: 'Mindestbestellung',
    customize: 'Anpassen',
    notes_placeholder: 'Besondere Anweisungen...',
    required: 'Erforderlich',
    optional: 'Optional',
    select_up_to: 'Wähle bis zu',
    kitchen_paused: 'Küche pausiert',
    kitchen_paused_msg: 'Das Restaurant nimmt derzeit keine Bestellungen an',
    back: 'Zurück',
    close: 'Schließen',
    loading: 'Laden...',
    error: 'Fehler',
    retry: 'Erneut versuchen',
    cancel: 'Abbrechen',
    confirm: 'Bestätigen',
    order_summary: 'Bestellübersicht',
    items: 'Artikel',
    copy_tracking: 'Tracking-Link kopieren',
    all: 'Alle',
    all_restaurants: 'Alle Restaurants',
    hero_subtitle: 'Entdecke die besten Restaurants in der Umgebung und bestelle zur Lieferung oder Abholung.',
    cat_food: 'Essen',
    cat_drinks: 'Getränke',
    cat_desserts: 'Desserts',
    cat_kids: 'Kinder',
    recommended: 'Empfohlen',
    explore: 'Entdecken',
    menu: 'Menü',
    mcat_pizza: 'Pizza',
    mcat_hamburguesas: 'Burger',
    mcat_cafeteria: 'Café',
    mcat_comida_tipica: 'Lokale Küche',
    mcat_sushi: 'Sushi',
    mcat_parrilla: 'Grill',
    mcat_postres: 'Desserts',
    mcat_mariscos: 'Meeresfrüchte',
    mcat_vegetariano: 'Vegetarisch',
    mcat_asiatica: 'Asiatisch',
    mcat_mexicana: 'Mexikanisch',
    mcat_italiana: 'Italienisch',
    mcat_bebidas: 'Getränke',
    mcat_desayunos: 'Frühstück',
    all_zones: 'Alle Zonen',
    all_categories: 'Alle Kategorien',
    no_restaurants: 'Keine Restaurants gefunden',
    no_restaurants_desc: 'Versuche, deine Suchfilter anzupassen, um mehr Ergebnisse zu sehen.',
    clear_filters: 'Filter löschen'
  },
  pt: {
    home: 'Início',
    restaurants: 'Restaurantes',
    search_placeholder: 'Buscar restaurantes ou comidas...',
    hero_title1: 'O marketplace gastronômico de',
    hero_title2: 'Los Santos',
    view_order: 'Ver pedido',
    product: 'produto',
    products: 'produtos',
    cart_empty: 'Seu carrinho está vazio',
    cart_empty_desc: 'Você ainda não adicionou nenhum produto ao seu pedido. Explore os restaurantes e encontre algo delicioso!',
    explore: 'Explorar restaurantes',
    add_to_cart: 'Adicionar ao pedido',
    checkout: 'Finalizar compra',
    subtotal: 'Subtotal',
    total: 'Total',
    delivery_fee: 'Taxa de entrega',
    delivery: 'Entrega',
    pickup: 'Retirada',
    dine_in: 'Comer no local',
    cart_title: 'Seu Pedido',
    cart_clear: 'Limpar',
    cart_checkout: 'Ir para pagamento',
    checkout_title: 'Confirmar Pedido',
    checkout_name: 'Nome',
    checkout_phone: 'Telefone',
    checkout_address: 'Endereço de entrega',
    checkout_payment: 'Método de pagamento',
    checkout_cash: 'Dinheiro',
    checkout_card: 'Cartão',
    checkout_sinpe: 'SINPE Móvil',
    checkout_notes: 'Notas do pedido',
    checkout_notes_placeholder: 'Instruções especiais...',
    checkout_place_order: 'Enviar pedido',
    checkout_placing: 'Enviando...',
    checkout_terms: 'Aceito os termos e condições',
    checkout_delivery_type: 'Tipo de entrega',
    confirm_title: 'Pedido enviado!',
    confirm_subtitle: 'Seu pedido foi recebido',
    confirm_order_number: 'Número do pedido',
    confirm_track: 'Rastrear pedido',
    confirm_whatsapp: 'Enviar por WhatsApp',
    confirm_copy: 'Copiar link',
    confirm_copied: 'Copiado!',
    confirm_no_order: 'Nenhum pedido recente',
    confirm_back: 'Voltar ao início',
    tracking_title: 'Rastreamento do pedido',
    tracking_not_found: 'Pedido não encontrado',
    status_new: 'Pedido recebido',
    status_accepted: 'Pedido aceito',
    status_preparing: 'Em preparação',
    status_ready: 'Pedido pronto',
    status_searching_driver: 'Buscando motorista',
    status_out_for_delivery: 'A caminho',
    status_delivered: 'Entregue',
    status_cancelled: 'Cancelado',
    featured: 'Destaque',
    closed: 'Fechado',
    free_delivery: 'Entrega grátis',
    min_order: 'Pedido mínimo',
    customize: 'Personalizar',
    notes_placeholder: 'Instruções especiais...',
    required: 'Obrigatório',
    optional: 'Opcional',
    select_up_to: 'Selecione até',
    kitchen_paused: 'Cozinha pausada',
    kitchen_paused_msg: 'O restaurante não está aceitando pedidos no momento',
    back: 'Voltar',
    close: 'Fechar',
    loading: 'Carregando...',
    error: 'Erro',
    retry: 'Tentar novamente',
    cancel: 'Cancelar',
    confirm: 'Confirmar',
    order_summary: 'Resumo do pedido',
    items: 'itens',
    copy_tracking: 'Copiar link de rastreamento',
    all: 'Todas',
    all_restaurants: 'Todos os restaurantes',
    hero_subtitle: 'Descubra os melhores restaurantes da região e peça para entrega ou retirada.',
    cat_food: 'Comida',
    cat_drinks: 'Bebidas',
    cat_desserts: 'Sobremesas',
    cat_kids: 'Crianças',
    recommended: 'Recomendados',
    explore: 'Explorar',
    menu: 'Menu',
    mcat_pizza: 'Pizza',
    mcat_hamburguesas: 'Hambúrgueres',
    mcat_cafeteria: 'Cafeteria',
    mcat_comida_tipica: 'Comida Típica',
    mcat_sushi: 'Sushi',
    mcat_parrilla: 'Grelhados',
    mcat_postres: 'Sobremesas',
    mcat_mariscos: 'Frutos do Mar',
    mcat_vegetariano: 'Vegetariano',
    mcat_asiatica: 'Asiática',
    mcat_mexicana: 'Mexicana',
    mcat_italiana: 'Italiana',
    mcat_bebidas: 'Bebidas',
    mcat_desayunos: 'Café da Manhã',
    all_zones: 'Todas as zonas',
    all_categories: 'Todas as categorias',
    no_restaurants: 'Nenhum restaurante encontrado',
    no_restaurants_desc: 'Tente ajustar seus filtros de busca para ver mais resultados.',
    clear_filters: 'Limpar filtros'
  },
  zh: {
    home: '首页',
    restaurants: '餐厅',
    search_placeholder: '搜索餐厅或美食...',
    hero_title1: '美食广场',
    hero_title2: '洛斯桑托斯',
    view_order: '查看订单',
    product: '件商品',
    products: '件商品',
    cart_empty: '您的购物车是空的',
    cart_empty_desc: '您还没有添加任何商品到订单中。探索餐厅，发现美味！',
    explore: '探索餐厅',
    add_to_cart: '加入订单',
    checkout: '去结算',
    subtotal: '小计',
    total: '总计',
    delivery_fee: '配送费',
    delivery: '外卖配送',
    pickup: '到店自取',
    dine_in: '堂食',
    cart_title: '您的订单',
    cart_clear: '清空',
    cart_checkout: '去结算',
    checkout_title: '确认订单',
    checkout_name: '姓名',
    checkout_phone: '电话',
    checkout_address: '配送地址',
    checkout_payment: '支付方式',
    checkout_cash: '现金',
    checkout_card: '银行卡',
    checkout_sinpe: 'SINPE Móvil',
    checkout_notes: '订单备注',
    checkout_notes_placeholder: '特殊说明...',
    checkout_place_order: '下单',
    checkout_placing: '提交中...',
    checkout_terms: '我接受条款和条件',
    checkout_delivery_type: '配送方式',
    confirm_title: '订单已提交！',
    confirm_subtitle: '您的订单已收到',
    confirm_order_number: '订单号',
    confirm_track: '追踪订单',
    confirm_whatsapp: '通过WhatsApp发送',
    confirm_copy: '复制链接',
    confirm_copied: '已复制！',
    confirm_no_order: '没有最近的订单',
    confirm_back: '返回首页',
    tracking_title: '订单追踪',
    tracking_not_found: '未找到订单',
    status_new: '订单已接收',
    status_accepted: '订单已接受',
    status_preparing: '准备中',
    status_ready: '订单就绪',
    status_searching_driver: '正在寻找骑手',
    status_out_for_delivery: '配送中',
    status_delivered: '已送达',
    status_cancelled: '已取消',
    featured: '推荐',
    closed: '已关闭',
    free_delivery: '免费配送',
    min_order: '最低订单',
    customize: '自定义',
    notes_placeholder: '特殊说明...',
    required: '必选',
    optional: '可选',
    select_up_to: '最多选择',
    kitchen_paused: '厨房暂停',
    kitchen_paused_msg: '餐厅目前不接受订单',
    back: '返回',
    close: '关闭',
    loading: '加载中...',
    error: '错误',
    retry: '重试',
    cancel: '取消',
    confirm: '确认',
    order_summary: '订单摘要',
    items: '商品',
    copy_tracking: '复制追踪链接',
    all: '全部',
    all_restaurants: '所有餐厅',
    hero_subtitle: '发现该地区最好的餐厅，支持外卖或自取。',
    cat_food: '食物',
    cat_drinks: '饮料',
    cat_desserts: '甜点',
    cat_kids: '儿童',
    recommended: '推荐',
    explore: '探索',
    menu: '菜单',
    mcat_pizza: '披萨',
    mcat_hamburguesas: '汉堡',
    mcat_cafeteria: '咖啡厅',
    mcat_comida_tipica: '当地美食',
    mcat_sushi: '寿司',
    mcat_parrilla: '烧烤',
    mcat_postres: '甜点',
    mcat_mariscos: '海鲜',
    mcat_vegetariano: '素食',
    mcat_asiatica: '亚洲菜',
    mcat_mexicana: '墨西哥菜',
    mcat_italiana: '意大利菜',
    mcat_bebidas: '饮品',
    mcat_desayunos: '早餐',
    all_zones: '所有区域',
    all_categories: '所有类别',
    no_restaurants: '未找到餐厅',
    no_restaurants_desc: '尝试调整搜索过滤条件以查看更多结果。',
    clear_filters: '清除过滤'
  }
};
interface I18nContextType {
  lang: Language;
  setLang: (lang: Language) => void;
  t: (key: string) => string;
}
const I18nContext = createContext<I18nContextType | undefined>(undefined);
export function LanguageProvider({
  children
}: {
  children: ReactNode;
}) {
  const [lang, setLangState] = useState<Language>('es');
  useEffect(() => {
    // 1. Check localStorage
    const savedLang = localStorage.getItem('noiza_lang') as Language;
    if (savedLang && translations[savedLang]) {
      setLangState(savedLang);
      return;
    }
    // 2. Check browser language
    const browserLang = navigator.language.split('-')[0] as Language;
    if (translations[browserLang]) {
      setLangState(browserLang);
      return;
    }
    // 3. Fallback to Spanish (already set as default state)
  }, []);
  const setLang = (newLang: Language) => {
    setLangState(newLang);
    localStorage.setItem('noiza_lang', newLang);
  };
  const t = (key: string): string => {
    // Fallback to Spanish if the key is missing in the current language
    return translations[lang][key] || translations['es'][key] || key;
  };
  return <I18nContext.Provider value={{
    lang,
    setLang,
    t
  }} data-id="element-1734">
      {children}
    </I18nContext.Provider>;
}
export function useLanguage() {
  const context = useContext(I18nContext);
  if (context === undefined) {
    throw new Error('useLanguage must be used within a LanguageProvider');
  }
  return context;
}
/**
 * Helper to extract translated fields from database records.
 * Expects records to optionally have a `translations` JSONB column:
 * { "en": { "name": "Burger", "description": "..." }, "de": { ... } }
 */
export function getLocalizedField(obj: any, field: string, lang: Language): string {
  if (!obj) return '';
  if (lang === 'es') return obj[field] || '';
  // Try to get the translation, fallback to Spanish (base field)
  return obj.translations?.[lang]?.[field] || obj[field] || '';
}